import { TaskType } from '@const/consts'
import { Nullable } from '@store/types'

export const getSubmitButtonTranslationKey = (
  taskType: TaskType,
  taskCounter: Nullable<number>,
): string => {
  switch (taskType) {
    case TaskType.SIGNING:
      return taskCounter === 0
        ? 'envelope:signer.next'
        : 'envelope:actions.finish'
    case TaskType.APPROVAL:
      return 'envelope:actions.approve'
    case TaskType.ACQUAINTANCE:
      return 'envelope:actions.acquaint'
  }
}
